import type { FormattedProductBundle } from 'reducers/detail/productDetail';
import type { SizeChartModalContent } from 'components/common/SizeChartModal';
import { track } from 'apis/amethyst';
import { evViewSizeChart } from 'events/product';
import { getStyleByColor, hasSizeChartAccordionSection, isKidsShoe } from 'helpers/ProductUtils';
import { SIZE_CHART_ACCORDION_HEADING } from 'constants/product';
import useMartyContext from 'hooks/useMartyContext';
import { Accordion } from 'components/common/Accordion';
import SizeCharts from 'components/productdetail/description/SizeCharts';

interface SizeChartAccordionProps {
  colorId: string;
  openSizeChartModal: (content: SizeChartModalContent) => void;
  productDetail?: FormattedProductBundle;
}

export const SizeChartAccordion = ({ productDetail, openSizeChartModal, colorId }: SizeChartAccordionProps) => {
  const {
    marketplace: {
      pdp: { showDescriptionSizeChart },
      is6pm
    }
  } = useMartyContext();

  const trackViewSizeChart = () => {
    track(() => [evViewSizeChart, {}]);
  };

  if (!productDetail) {
    return null;
  }

  const { defaultProductType, description } = productDetail;

  if (!defaultProductType || !description) {
    return null;
  }

  if (
    !hasSizeChartAccordionSection({
      defaultProductType,
      description,
      showDescriptionSizeChart
    })
  ) {
    return null;
  }

  const { styles } = productDetail;
  const { taxonomyAttributes } = getStyleByColor(styles, colorId);

  return (
    <div data-test-id="sizeChartAccordion">
      <Accordion heading={SIZE_CHART_ACCORDION_HEADING}>
        <ul className="isolate">
          <SizeCharts
            showKidsShoeMeasurementLink={!is6pm && isKidsShoe(taxonomyAttributes)}
            descriptionItems={description}
            openSizeChartModal={openSizeChartModal}
            productType={defaultProductType}
            trackViewSizeChart={trackViewSizeChart}
          />
        </ul>
      </Accordion>
    </div>
  );
};
